import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import LockedInputAdornmentPicker from './LockedInputAdornmentPicker';

const styles = () => ({
  root: {},
});

const LockedInput = ({
  className,
  classes,
  label,
  value,
  mask,
  InputComponent,
  LockedInputAdornmentProps,
}) => {
  return (
    <TextField
      className={classNames(className, classes.root)}
      disabled
      label={label}
      value={value || mask}
      InputProps={{
        inputComponent: InputComponent,
        endAdornment: (
          <LockedInputAdornmentPicker
            {...LockedInputAdornmentProps}
            className={classes.adornment}
          />
        ),
      }}
    />
  );
};

LockedInput.defaultProps = {
  className: '',
  mask: '',
  InputComponent: undefined,
  LockedInputAdornmentProps: {},
};

LockedInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  mask: PropTypes.string,
  value: PropTypes.string.isRequired,
  InputComponent: PropTypes.object,
  LockedInputAdornmentProps: PropTypes.object,
};

export default withStyles(styles)(LockedInput);
